import { CARTEIRAS_CHANGED, CARTEIRA_SELECTED, CARTEIRAS_LOGOUT } from '../../const/actionsType';

import { dates } from 'investira.sdk';

const INITIAL_STATE = {
  data: [],
  current: {},
  updatedAt: dates.toDate()
};

const RESET_STATE = {
  ...INITIAL_STATE
};

function carteirasReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CARTEIRAS_CHANGED:
      return {
        ...state,
        data: action.payload,
        updatedAt: dates.toDate()
      };
    case CARTEIRA_SELECTED:
      return {
        ...state,
        current: action.payload
      };
    case CARTEIRAS_LOGOUT:
      return {
        ...RESET_STATE
      };
    default:
      return state;
  }
}

export default carteirasReducer;
